import { ospThemes } from "@ospweb/sdk-ui";
import { memo } from "react";
import { cn } from "utils";
import { SignalLevel, SignalLevelType } from "../constants";
import { SIGNAL_LEVELS, SignalLevelConfig } from "@/src/components";

interface SignalLevelIndicatorProps {
  className?: string;
  signalLevel?: SignalLevelType;
  variant?: "default" | "timeline";
  currentSignalFont?: string;
}

const SignalLevelIndicator = ({
  className,
  signalLevel = SignalLevel.NEUTRAL,
  variant = "default",
  currentSignalFont = "body_medium_s",
}: SignalLevelIndicatorProps) => {
  const activeSignal = signalLevel;

  return (
    <div
      className={cn(
        "w-full flex justify-between items-center gap-1 border rounded-2 border-border_white_transparent10",
        variant === "timeline" ? "py-0 h-12 items-unset px-2 " : "md:p-6 p-3",
        className,
      )}
    >
      {/* 信号条 */}
      {SIGNAL_LEVELS.map((level: SignalLevelConfig) => {
        const currentSignal = activeSignal === level.key;
        return (
          <div
            key={level.key}
            className={cn("flex-1", variant === "timeline" && "h-8 gap-2")}
          >
            <div
              key={level.key}
              className={cn(
                "flex flex-col items-center justify-center transition-all duration-200 text-center body_s text-content_tertiary h-8",
                currentSignal && level.linearBGClassName,
              )}
              style={{
                color: currentSignal
                  ? level.activeColor
                  : ospThemes.colors.content_tertiary,
              }}
            >
              <span
                className={cn(
                  "body_s text-center",
                  currentSignal && currentSignalFont,
                )}
              >
                {level.label}
              </span>
            </div>

            <div
              className={cn("w-full h-2 transition-all duration-200")}
              style={{
                backgroundColor: currentSignal
                  ? level.activeBgColor
                  : level.bgColor,
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default memo(SignalLevelIndicator);
